import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import api from "api/api";
import serverCall from "api/serverCall";
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";
import { Send } from "iconsax-react";
import { dispatch } from "store";
import { openSnackbar } from "store/reducers/snackbar";

interface Props {
  open: boolean;
  handleClose: (status: boolean) => void;
}

export default function ConnectKiteDialog({ open, handleClose }: Props) {
  const handleCancel = () => {
    handleClose(false);
  };

  const handleConnect = async () => {
    try {
      const response = await serverCall.get<string>(
        api.getZerodhaLoginUrlAdmin()
      );
      window.open(response, "_self");
    } catch (error: any) {
      console.error("error", error);
      const errorMessage = error?.response?.data?.message;
      dispatch(
        openSnackbar({
          open: true,
          close: true,
          message:
            errorMessage ?? "Failed to get the url, please try again later",
          variant: "alert",
          alert: {
            color: "error",
          },
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        })
      );
      console.error("error", error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="connect-kite-title"
      aria-describedby="connect-kite-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="success"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <Send variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              Connect to Kite
            </Typography>
            <Typography align="center">
              Connect to your Zerodha Kite account to access real-time prices
              and other essential information.
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleCancel}
              color="error"
              variant="outlined"
            >
              Close
            </Button>
            <Button
              onClick={handleConnect}
              fullWidth
              variant="contained"
              color="primary"
            >
              Connect
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
